
/* injects from baggage-loader */

import tabBookModule from './tab-book/tab-book.module';
import tabBookReversoModule from './tab-book-reverso/tab-book-reverso.module';
//chef
import tabDeviceModule from './tab-device/tab-device.module';
import tabDeviceChefModule from './tab-device-chef/tab-device-chef.module';
import campoChefDevice from './campo-chef-device/campo-chef-device.module';
//chef
import countdownModule from './countdown/countdown.module';
import statusBarModule from './status-bar/status-bar.module';
import levelBarModule from './level-bar/level-bar.module';

const shared = angular.module('ui-module', [
    tabBookModule.name,
    tabBookReversoModule.name,
    //chef
    tabDeviceModule.name,
    tabDeviceChefModule.name,
    campoChefDevice.name,
    //chef
    countdownModule.name,
    statusBarModule.name,
    levelBarModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/ui/index.js